import { Route, Routes } from "react-router-dom";
import EspecializacionAlcantarillado from "../../src/newPages/posgrados/EspecializacionAlcantarillado";
import EspecializacionVias from "../../src/newPages/posgrados/EspecializacionVias";
import EspecializacionGeoinformacion from "../../src/newPages/posgrados/EspecializacionGeoinformacion";
import EspecializacionLogistica from "../../src/newPages/posgrados/EspecializacionLogistica";
import EspecializacionTributacion from "../../src/newPages/posgrados/EspecializacionTributacion";
import DoctoradoQuimica from "../../src/newPages/posgrados/DoctoradoQuimica";
import MaestriaAnalisisBiologico from "../../src/newPages/posgrados/MaestriaAnalisisBiologico";
import MaestriaEducacionCurriculo from "../../src/newPages/posgrados/MaestriaEducacionCurriculo";
import MaestriaDatos from "../newPages/posgrados/MaestriaDatos";
import MaestriaContenidosIA from "../newPages/posgrados/MaestriaContenidosIA";
import EspecializacionBlockChain from "../newPages/posgrados/EspecializacionBlockChain";
import MaestriaDerechoAdministrativo from "../newPages/posgrados/MaestriaDerechoAdministrativo";
import MaestriaLiteratura from "../newPages/posgrados/MaestriaLiteratura";
import MaestriaGestionFinanciera from "../newPages/posgrados/MaestriaGestionFinanciera";
import MaestriaDerechoTributario from "../newPages/posgrados/MaestriaDerechoTributario";
import EspecializacionGeotecnia from "../newPages/posgrados/EspecializacionGeotecnia";
import EspecializacionMedicinaFamiliar from "../newPages/posgrados/EspecializacionMedicinaFamiliar";
import MaestriaBioeconomia from "../newPages/posgrados/MaestriaBioeconomia";
import EspecializacionMecanicaSuelos from "../newPages/posgrados/EspecializacionMecanicaSuelos";
import MaestriaComunicacionEstrategica from "../newPages/posgrados/MaestriaComunicacionEstrategica";
import MaestriaGeologia from "../newPages/posgrados/MaestriaGeologia";
import MaestriaFarmaciaAsistencial from "../newPages/posgrados/MaestriaFarmaciaAsistencial";
import EspecializacionPatrimonioPaleontologico from "../newPages/posgrados/EspecializacionPatrimonioPaleontologico";
import MaestriaCienciasAmbientales from "../newPages/posgrados/MaestriaCienciasAmbientales";
import MaestriaEducacionInclusiva from "../newPages/posgrados/MaestriaEducacionInclusiva";
import MaestriaInvestigacionEducacion from "../newPages/posgrados/MaestriaInvestigacionEducacion";
import MaestriaCienciasPoliticas from "../newPages/posgrados/MaestriaCienciasPoliticas";
import EspecializacionImageonologia from "../newPages/posgrados/EspecializacionImageonologia";
import MaestriaRecursosNaturales from "../newPages/posgrados/MaestriaRecursosNaturales";
import MaestriaTalentoHumano from "../newPages/posgrados/MaestriaTalentoHumano";
import MaestriaDireccionFinanciera from "../newPages/posgrados/MaestriaDireccionFinanciera";
import MaestriaGestionEmpresarial from "../newPages/posgrados/MaestriaGestionEmpresarial";
import MaestriaMarketing from "../newPages/posgrados/MaestriaMarketing";
import MaestriaAdministracionMBA from "../newPages/posgrados/MaestriaAdministracionMBA";
import MaestriaTransformacionDigital from "../newPages/posgrados/MaestriaTransformacionDigital";
import MaestriaGestionProyectos from "../newPages/posgrados/MaestriaGestionProyectos";
import MaestriaAuditoria from "../newPages/posgrados/MaestriaAuditoria";
import MaestriaIAAplicada from "../newPages/posgrados/MaestriaIAAplicada";
import MaestriaIndustria from "../newPages/posgrados/MaestriaIndustria";
import MaestriaPlanificacionTerritorio from "../newPages/posgrados/MaestriaPlanificacionTerritorio";
import MaestriaFinanzas from "../newPages/posgradosnew/MaestriaFinanzas";
import MaestriaRecursosHidricos from "../newPages/posgradosnew/MaestriaRecursosHidricos";
function RoutesPosgrados() {
  return (
    <>
      <Routes>
        <Route
          path="/maestria-finanzas"
          element={<MaestriaFinanzas></MaestriaFinanzas>}
        />{" "}
        <Route
          path="/doctorado-quimica"
          element={<DoctoradoQuimica></DoctoradoQuimica>}
        />
     
        <Route
          path="/especializacion-patrimonio-paleontologico"
          element={
            <EspecializacionPatrimonioPaleontologico></EspecializacionPatrimonioPaleontologico>
          }
        />
   
        <Route
          path="/maestria-educacion-curriculo"
          element={<MaestriaEducacionCurriculo></MaestriaEducacionCurriculo>}
        />
        <Route
          path="/maestria-investigacion-educacion"
          element={
            <MaestriaInvestigacionEducacion></MaestriaInvestigacionEducacion>
          }
        />
        <Route
          path="/maestria-educacion-inclusiva"
          element={<MaestriaEducacionInclusiva></MaestriaEducacionInclusiva>}
        />
    
        <Route
          path="/maestria-datos"
          element={<MaestriaDatos></MaestriaDatos>}
        />
      
        <Route
          path="/maestria-comunicacion-estrategica"
          element={
            <MaestriaComunicacionEstrategica></MaestriaComunicacionEstrategica>
          }
        />
        <Route
          path="/maestria-derecho-administrativo"
          element={
            <MaestriaDerechoAdministrativo></MaestriaDerechoAdministrativo>
          }
        />
        <Route
          path="/maestria-derecho-tributario"
          element={<MaestriaDerechoTributario></MaestriaDerechoTributario>}
        />
        <Route
          path="/maestria-comunicacion-ia"
          element={<MaestriaContenidosIA></MaestriaContenidosIA>}
        />

        <Route
          path="/maestria-literatura"
          element={<MaestriaLiteratura></MaestriaLiteratura>}
        />
        <Route
          path="/maestria-geologia"
          element={<MaestriaGeologia></MaestriaGeologia>}
        />
        <Route
          path="/maestria-ciencias-politicas"
          element={<MaestriaCienciasPoliticas></MaestriaCienciasPoliticas>}
        />
    
        <Route
          path="/especializacion-alcantarillado"
          element={
            <EspecializacionAlcantarillado></EspecializacionAlcantarillado>
          }
        />
        <Route
          path="/especializacion-vias"
          element={<EspecializacionVias></EspecializacionVias>}
        />
        <Route
          path="/especializacion-geotecnia"
          element={<EspecializacionGeotecnia></EspecializacionGeotecnia>}
        />
        <Route
          path="/especializacion-geoinformacion"
          element={
            <EspecializacionGeoinformacion></EspecializacionGeoinformacion>
          }
        />
   
        <Route
          path="/especializacion-blockchain"
          element={<EspecializacionBlockChain></EspecializacionBlockChain>}
        />
        <Route
          path="/especializacion-logistica"
          element={<EspecializacionLogistica></EspecializacionLogistica>}
        />
     
        <Route
          path="/especializacion-mecanica-suelos"
          element={
            <EspecializacionMecanicaSuelos></EspecializacionMecanicaSuelos>
          }
        />
     
   
        <Route
          path="/maestria-talento-humano"
          element={<MaestriaTalentoHumano></MaestriaTalentoHumano>}
        />
        <Route
          path="/maestria-direccion-financiera"
          element={<MaestriaDireccionFinanciera></MaestriaDireccionFinanciera>}
        />
        <Route
          path="/maestria-gestion-empresarial"
          element={<MaestriaGestionEmpresarial></MaestriaGestionEmpresarial>}
        />
        <Route
          path="/maestria-ia-aplicada"
          element={<MaestriaIAAplicada></MaestriaIAAplicada>}
        />
        <Route
          path="/maestria-gestion-proyectos"
          element={<MaestriaGestionProyectos></MaestriaGestionProyectos>}
        />
        <Route
          path="/maestria-marketing"
          element={<MaestriaMarketing></MaestriaMarketing>}
        />
        <Route
          path="/mba-online"
          element={<MaestriaAdministracionMBA></MaestriaAdministracionMBA>}
        />
        <Route
          path="/mba-transformacion-digital"
          element={
            <MaestriaTransformacionDigital></MaestriaTransformacionDigital>
          }
        />
   
        <Route
          path="/maestria-industria"
          element={<MaestriaIndustria></MaestriaIndustria>}
        />
        <Route
          path="/maestria-planificacion-territorio"
          element={
            <MaestriaPlanificacionTerritorio></MaestriaPlanificacionTerritorio>
          }
        />

           <Route
          path="/maestria-recursos-hidricos"
          element={
            <MaestriaRecursosHidricos></MaestriaRecursosHidricos>
          }
        />
      </Routes>{" "}
    </>
  );
}

export default RoutesPosgrados;
